import React from 'react';
import PropTypes from 'prop-types';
import Button from 'tailwind-components/Button/Button';
import { Plus } from 'lucide-react';
import { cn } from 'lib/utils';

export default function NewEventTrigger({ onOpenAdd, className }) {
  return (
    <div className={cn('flex min-w-0 w-full justify-stretch', className)}>
      <Button
        text='Add Event'
        variant='primaryLight'
        icon={<Plus />}
        size='small'
        fill
        onClick={onOpenAdd}
      />
    </div>
  );
}

NewEventTrigger.propTypes = {
  onOpenAdd: PropTypes.func.isRequired,
  className: PropTypes.string
};
